<template>
  <div>
    <template>
      <div>
        <a-collapse accordion v-model="activeKey">
          <a-collapse-panel key="1" header="Procesos disciplinarios">
            <procesos-disciplinarios @detalle="getDetalle" @archivado="archivado" ref="proceso"/>
          </a-collapse-panel>
          <a-collapse-panel key="2" header="Detalle de proceso disciplinario" :disabled="!idAttention">
            <a-alert
              v-if="visibleAlert && isArchived"
              message="Advertencia"
              type="warning"
              closable
              :after-close="handleCloseAlert"
              show-icon
            >
              <template slot="description">
                Este proceso disciplinario esta <strong>{{detalle.status_desc}}</strong>.
              </template>
            </a-alert>
            <a-alert v-if="current == 2 && detalle.additional && detalle.status == null"
                     :message="messageAdditional"
                     banner/>
            <a-spin :spinning="spinning">
              <a-steps size="small" :current="current" type="navigation" :style="stepStyle">
                <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
              </a-steps>
              <g-descriptions-detail v-if="detalle" :detalle="detalle" :valoresExpandidos="valoresExpandidos">
                <template v-slot:status_desc="{item}">
                  <a-badge v-if="item==='ARCHIVADO'" status="error" :text="item"/>
                  <a-badge v-else-if="item==='CERRADO'" status="error" :text="item"/>
                  <a-badge v-else status="processing" :text="item"/>
                </template>
                <template v-if="current > 0" v-slot:call_date_desc="{item}">
                  <a-date-picker v-if="canEditDate[keyDate] && !isArchived" style="width: 100%"
                                 type="date"
                                 :valueFormat="dateFormat"
                                 v-model="detalle[keyDate]"
                                 :default-value="now"
                  />
                  <div v-else>
                    {{dateDesc}}
                  </div>
                </template>
                <template v-if="current > 0" v-slot:call_obs="{item}">
                  <a-input v-if="canEditObs[keyObs] && !isArchived" type="textarea" v-model="detalle[keyObs]"/>
                  <div v-else>
                    {{detalle[keyObs]}}
                  </div>
                </template>
                <template slot="items" v-if="current == steps.length - 1">
                  <a-descriptions-item>
                    <template slot="label">
                      {{$t('Sanción')}}
                    </template>
                    <template>
                      {{this.sancion}}
                    </template>
                  </a-descriptions-item>
                </template>
                <template slot="items" v-if="current == 3">
                  <a-descriptions-item>
                    <template slot="label">
                      <a-tag color="red">
                        {{$t('Presenta Inconformidad')}}
                      </a-tag>
                    </template>
                    <a-radio-group :options="options" v-model="detalle.disapproval">
                    </a-radio-group>
                  </a-descriptions-item>
                  <a-descriptions-item v-if="detalle.disapproval" :label="$t('Inconformidad')">
                    <a-input style="width: 100%"
                             type="textarea"
                             v-model="detalle.disapproval_obs">
                    </a-input>
                  </a-descriptions-item>
                </template>
                <template slot="items" v-if="current == 3">
                  <a-descriptions-item>
                    <template slot="label">
                      <a-tag color="red">
                        {{$t('Sancionar')}}
                      </a-tag>
                    </template>
                    <a-radio-group :options="options" v-model="detalle.sanction">
                    </a-radio-group>
                  </a-descriptions-item>
                  <a-descriptions-item v-if="detalle.sanction" :label="$t('Sanción')">
                    <form-model-dropdown style="width: 100%"
                                         endpoint="hierarchy_lookup"
                                         v-model="detalle.id_h_sanction"
                                         :params="tipoSancion">
                    </form-model-dropdown>
                  </a-descriptions-item>
                </template>
              </g-descriptions-detail>
            </a-spin>
            <div class="steps-action">
              <a-button icon="left" v-if="current > 0" style="margin-left: 8px" @click="prev">
                Anterior
              </a-button>
              <a-button icon="right" v-if="current < steps.length - 1" type="primary" @click="next">
                Siguiente
              </a-button>
              <template v-if="current != 2 || (detalle.additional==1 || detalle.additional==0)">
                <a-button
                  v-if="current > 0 && (canEditObs[keyObs] && canEditDate[keyDate]) && !isArchived && current <= currentBD+2"
                  :loading="spinning"
                  icon="plus"
                  ghost
                  type="primary"
                  @click="guardar"
                >
                  Guardar
                </a-button>
              </template>
              <template
                v-if="current == 3 && $getConfigValue('PROCESOS_DISCIPLINARIO_GUARDAR_ETAPA_4', 'NO') === 'SI' && this.detalle.status == null">
                <a-button
                  v-if="!this.$isEmpty(this.detalle.sanction) && (this.$isEmpty(this.detalle.disapproval) || !this.$isEmpty(this.detalle.disapproval) )"
                  :loading="spinning"
                  icon="plus"
                  ghost
                  type="primary"
                  @click="guardar"
                >
                  Guardar Inconformidad
                </a-button>
              </template>
              <a-button
                v-if="additional && current == 2 && currentBD == 1 && (detalle.additional == null || detalle.additional == 0)"
                :loading="spinning"
                icon="up"
                ghost
                type="danger"
                @click="updateAdditional"
              >
                Adicionales
              </a-button>
            </div>
          </a-collapse-panel>
          <a-collapse-panel key="3" header="Registro fotográfico" :disabled="!idAttention">
            <photo-graphic-record v-if="idAttention" :id_attention="idAttention" :step="currentBD"/>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </template>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  const MAXIMO_PASOS = 7
  const options = [
    {label: 'SI', value: true},
    {label: 'NO', value: false}
  ]

  export default {
    mounted () {
      this.now = moment().format('Y-MM-DD')
      this.httpClient = new HttpUtil()
      let steps = this.$getConfigValue('APLICA_PROCESO_DISCIPLINARIO', 'defaultSteps')
      this.additional = steps === 'defaultSteps'
      if (!this.additional) {
        steps = steps.split(',')
        let size = steps.length
        this.max_step = size - 1
        if (size < MAXIMO_PASOS) {
          steps.forEach((step) => {
            this.steps.push({title: step})
          })
        } else {
          this.$notification.error({
            message: 'Error de configuración',
            description: (h) => {
              return h('div', {
                domProps: {
                  innerHTML: '<p>El parametro de configuraci&oacute;n esta mal configurado, m&aacute;ximo son 6 pasos separados por <strong>comas(,)</strong>.<br /><strong>Ejemplo:</strong></p>\n' +
                    '<p>Creaci&oacute;n,Citaci&oacute;n a descargos,Acta de descargos,Resoluci&oacute;n disciplinaria</p>'
                }
              })
            },
            duration: 60
          })
        }
      } else {
        this.max_step = 5
        this.steps.push(
          {
            title: 'Creación'
          },
          {
            title: 'Citación a descargos'
          },
          {
            title: 'Acta de descargos'
          },
          {
            title: 'Resolución disciplinaria'
          },
          {
            title: 'Resuelve recursos'
          },
          {
            title: 'Cierre del proceso'
          })
      }
    },
    data () {
      return {
        // additional es un campo que sirve para manejo de notificaciones en sevicol
        additional: false,
        flagEnd: false,
        options,
        tipoSancion: {h_lookup_type: 'TIPO_SANCION'},
        iForm: {},
        colSpan: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        },
        max_step: 0,
        now: '',
        sancion: '',
        dateFormat: 'Y-MM-DD',
        currentBD: 0,
        spinning: false,
        visibleAlert: true,
        canEditDate: {},
        canEditObs: {},
        activeKey: 1,
        detalle: {},
        valoresExpandidos: [],
        current: 0,
        steps: [],
        stepStyle: {
          marginBottom: '60px',
          boxShadow: '0px -1px 0 0 #e8e8e8 inset'
        }
      }
    },
    methods: {
      updateAdditional () {
        this.$confirm({
          title: 'Confirmación',
          content: '¿Desea adicionar días de prueba?',
          okText: 'Sí',
          cancelText: 'No',
          onOk: () => {
            return new Promise((resolve, reject) => {
              this.updateAtention(true, true).then(() => {
                resolve()
              }).catch((error) => {
                reject(error)
              })
            })
          },
          onCancel: () => {
            return new Promise((resolve, reject) => {
              this.updateAtention(false, true).then(() => {
                resolve()
              }).catch((error) => {
                reject(error)
              })
            })
          }
        })
      },
      getDetalle (detalle) {
        this.detalle = detalle.detalle
        this.sancion = this.detalle.h_sanction
        this.valoresExpandidos = detalle.valoresExpandidos
        this.activeKey = 2
        this.$forceUpdate()
      },
      next () {
        if (this.current == 3 && (this.detalle.disapproval === false)) {
          this.current = this.max_step
          if (!this.$isEmpty(this.detalle.sanction)) {
            this.getSancion()
          }
        } else {
          if (this.current == 4 && !this.$isEmpty(this.detalle.sanction)) {
            this.current++
            this.getSancion()
          } else {
            this.current++
          }
        }
      },
      prev () {
        if (this.current == this.max_step && this.detalle.disapproval === false) {
          this.current = this.max_step - 2
        } else {
          this.current--
        }
      },
      setCanEdit () {
        // Obtiene la logitud
        let temp = {...this.detalle}
        temp.sancion = this.sancion
        let size = Object.keys(temp).length
        for (let i = 0; i < size; i++) {
          let keyDate = 'call_date_step_' + (i + 1)
          // Verifica que la clave exista en el objeto y la agrega al objeto
          if ((keyDate in temp)) {
            this.canEditDate[keyDate] = this.$isEmpty(temp[keyDate])
          }
          let keyObs = 'call_obs_step_' + (i + 1)
          if ((keyDate in temp)) {
            this.canEditObs[keyObs] = this.$isEmpty(temp[keyObs])
          }
        }
      },
      guardar () {
        let canSend = true
        if (this.detalle[this.keyObs]) {
          if (!this.detalle[this.keyDate]) {
            this.detalle[this.keyDate] = this.now
          }

          if (this.detalle.disapproval === false) {
            if (this.currentBD == this.max_step) {
              canSend = !this.$isEmpty(this.detalle.sanction)
              if (canSend) {
                this.detalle['status'] = false
                this.detalle['status_desc'] = 'CERRADO'
                this.flagEnd = true
              }
            }
          } else {
            // si el paso actual es igual a los pasos maximos se cierra el proceso.
            if (this.currentBD == this.max_step) {
              canSend = !this.$isEmpty(this.detalle.sanction) && !this.$isEmpty(this.detalle.disapproval)
              if (canSend) {
                this.detalle['status'] = false
                this.detalle['status_desc'] = 'CERRADO'
                this.flagEnd = true
              }
            }
          }
          if (canSend) {
            this.spinning = true
            this.httpClient.getInstance().put('atention_call/' + this.idAttention, this.detalle)
              .then((res) => {
                this.currentBD = res.data.step
                this.$refs.proceso && this.$refs.proceso.loadData()
                Mensajes.success('Correcto', 'Datos guardados correctamente')
                this.setCanEdit()
                this.$forceUpdate()
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              }).then(() => {
                this.spinning = false
              })
          } else {
            Mensajes.error('Error', 'El campo sancionar es requeridos.')
          }
        } else {
          Mensajes.error('Error', 'Los campos de observacion son requeridos.')
        }
      },
      handleCloseAlert () {
        this.visibleAlert = false
      },
      getCurrentStep () {
        this.spinning = true
        this.httpClient.getInstance().get('atention_call/current_step/' + this.idAttention).then((res) => {
          this.currentBD = res.data
          this.current = res.data
        }).catch(() => {
        }).then(() => {
          this.spinning = false
        })
      },
      getSancion () {
        this.spinning = true
        this.httpClient.getInstance().get('atention_call/get_sancion/' + this.getIdSancion).then((res) => {
          if (!this.$isEmpty(this.detalle.h_sanction)) {
            this.sancion = this.detalle.h_sanction
          } else {
            this.sancion = res.data
          }
        }).catch(() => {
        }).then(() => {
          this.spinning = false
        })
      },
      archivado () {
        this.flagEnd = false
        this.activeKey = 1
        this.detalle = {}
      },
      updateAtention (value, type = false) {
        let req = null
        this.loading = true
        if (!type) {
          req = {status: value}
        } else {
          req = {additional: value, is_additional: true}
        }
        return this.httpClient.getInstance().put('atention_call/' + this.idAttention, req)
          .then(() => {
            if (type) {
              Mensajes.success('Correcto', 'Datos guardados correctamente')
            }
            this.$refs.proceso && this.$refs.proceso.loadData()
            this.archivado()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          }).then(() => {
            this.loading = false
          })
      }
    },
    computed: {
      endStep () {
        return this.current == this.max_step
      },
      keyObs () {
        return 'call_obs_step_' + (this.current + 1)
      },
      keyDate () {
        return 'call_date_step_' + (this.current + 1)
      },
      dateDesc () {
        if (this.detalle[this.keyDate]) {
          return moment(this.detalle[this.keyDate]).format('YYYY-MM-DD')
        }
      },
      idAttention () {
        return this.detalle.id_atention
      },
      getEtapa () {
        return this.detalle.step
      },
      getInconformidad () {
        return this.detalle.disapproval
      },
      getIdSancion () {
        return this.detalle.id_h_sanction
      },
      isArchived () {
        return this.detalle.status !== null
      },
      messageAdditional () {
        let sN = this.detalle.additional + '' === '1' ? '' : 'no'
        return `Este proceso ${sN} requiere pruebas adicionales.`
      }
    },
    watch: {
      idAttention () {
        if (!this.$isEmpty(this.idAttention)) {
          this.visibleAlert = true
          this.setCanEdit()
          this.getCurrentStep()
        }
      },
      flagEnd () {
        if (this.flagEnd) {
          this.updateAtention(false)
        }
      }
    }
  }
</script>
<style scoped>
  .steps-content {
    border: 1px dashed #e9e9e9;
    border-radius: 2px;
    text-align: center;
  }

  .steps-action {
    margin-top: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ReporteNovedad/StepsProcesoDisciplinario.vue